<template>
  <div class="page">
    <!-- 左侧输入框 -->
    <div class="info">
      <div style="width: 24px;height: 24px; ">
        <img
          style="width:100%; height:100%; border-radius: 5px; "
          src="https://pub.fsgo365.cn/logo_icon.jpg"
        />
      </div>
      <!-- 下拉选项一 -->
      <div>
        <el-dropdown
          placement="bottom-start"
          trigger="click"
          @command="handleCommand($event, 'selectedCity')"
        >
          <span class="el-dropdown-link">
            {{ selectedCity }}
            <i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="北京">北京</el-dropdown-item>
            <el-dropdown-item command="上海">上海</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <!-- 下拉选项二 -->
      <div>
        <el-dropdown
          placement="bottom-start"
          trigger="click"
          @command="handleCommand($event, 'selectedRegion')"
        >
          <span class="el-dropdown-link">
            {{ selectedRegion }}
            <i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item
              :command="item.city"
              v-for="(item, index) in district[this.selectedCity].districts"
              :key="index"
            >
              {{ item.city }}
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>

      <div class="querySearchBox">
        <div class="line"></div>
        <div style="margin: 0px 10px;">
          <el-input
            v-model="inputContent"
            @focus="inputfocus"
            @blur="inputblur"
            @input="inputChange"
            clearable
            placeholder="请输入小区名称"
          ></el-input>
        </div>
        <i class="el-icon-search" @click="handleSelect"></i>
      </div>
    </div>
    <div class="result">
      <div class="title">
        可视区域内共有{{ this.totalCount }}套小区
        <div class="close-item">
          <i v-if="!DropdownDisplayManager" class="el-icon-arrow-down" @click="WebClick"></i>
          <i v-if="DropdownDisplayManager" class="el-icon-arrow-up" @click="WebClick"></i>
        </div>
      </div>

      <div
        style="display: flex; flex-direction: column; width: 100%; max-height: 349px;"
        v-if="DropdownDisplayManager"
      >
        <div>
          <div v-if="this.CellName.name != ''">
            <h3>
              <span
                class="cellName"
                @click="
                  osg.open(null, {}, '_blank', '/Neighborhood/' + (CellName._id || CellName.id))
                "
              >
                {{ this.CellName.name }}
              </span>
              <i class="el-icon-arrow-right"></i>
            </h3>
            <p style="font-size: 12px;color: #999">该小区共{{ workOrderList.length }}个工单</p>
          </div>
        </div>

        <template v-if="workOrderList.length > 0">
          <div class="plot_card">
            <div
              class="result_box"
              v-for="(item, index) in workOrderList"
              @click="osg.open(null, {}, '_blank', '/Flow/serviceAppointment/' + item._id)"
              :key="index"
            >
              <div style="width: 100px; height: 100%;">
                <el-image style="width: 100%; height: 100%;" :src="item.exts.imageUrl"></el-image>
              </div>
              <div
                style="font-size: 12px; flex: 1;
    margin-left: 10px;"
              >
                <div>工单编号：{{ item.orderNum }}</div>

                <div>详细地址：{{ item.address }}</div>
                <div>客户电话：{{ item.phone }}</div>
                <div>
                  <el-tag
                    v-for="(items, i) in osg
                      .formatCascadeMultiple('repairParts', item.exts.leakagesite)
                      .split('、')"
                    :key="i"
                    type="info"
                    color="#edf0f3"
                    size="mini"
                    style="font-size: 10px; margin: 2px;"
                  >
                    {{ items }}
                  </el-tag>
                </div>
              </div>
            </div>
          </div>
        </template>
        <template v-else>
          <el-empty
            :description="this.CellName.name ? '小区工单为空' : '您还没有选择小区'"
          ></el-empty>
        </template>
      </div>
    </div>
    <!-- 检索提示词 列表 -->
    <div class="result " style="z-index: 20;" v-if="showSearchSuggestions">
      <div class="title" v-if="filteredPoints.length == 0" style="color: #999;">
        无匹配结果换一个词试试吧
      </div>
      <div
        class="plot_card"
        @scroll="handleScroll"
        style="max-height: 400px;"
        v-if="filteredPoints.length > 0"
      >
        <div
          v-for="(item, index) in filteredPoints"
          :key="index"
          style="display: flex; align-items: center; height: 50px;"
          @mousedown.prevent="navigateToMarker(item)"
        >
          <el-tag
            type="info"
            size="mini"
            color="#edf0f3"
            style="color: #9399a5; padding: 0px 8px; margin-right: 12px;"
          >
            小区
          </el-tag>
          <div v-html="highlightMatches(item.name)"></div>
        </div>
      </div>
    </div>
    <div id="container" style="height: 100%;"></div>
  </div>
</template>

<script>
import AMapLoader from '@amap/amap-jsapi-loader'; //引入
var district = {
  北京: {
    adcode: '110000',
    districts: [
      {
        city: '北京',
        adcode: '110000',
        center: '116.405285,39.904989'
      },
      {
        city: '密云区',
        adcode: '110118',
        center: '116.843352,40.377362'
      },
      {
        city: '怀柔区',
        adcode: '110116',
        center: '116.637122,40.324272'
      },
      {
        city: '门头沟区',
        adcode: '110109',
        center: '116.105381,39.937183'
      },
      {
        city: '顺义区',
        adcode: '110113',
        center: '116.653525,40.128936'
      },
      {
        city: '朝阳区',
        adcode: '110105',
        center: '116.486409,39.921489'
      },
      {
        city: '通州区',
        adcode: '110112',
        center: '116.658603,39.902486'
      },
      {
        city: '大兴区',
        adcode: '110115',
        center: '116.338033,39.728908'
      },
      {
        city: '昌平区',
        adcode: '110114',
        center: '116.235906,40.218085'
      },
      {
        city: '西城区',
        adcode: '110102',
        center: '116.366794,39.915309'
      },
      {
        city: '东城区',
        adcode: '110101',
        center: '116.418757,39.917544'
      },
      {
        city: '房山区',
        adcode: '110111',
        center: '116.139157,39.735535'
      },
      {
        city: '石景山区',
        adcode: '110107',
        center: '116.195445,39.914601'
      },
      {
        city: '海淀区',
        adcode: '110108',
        center: '116.310316,39.956074'
      },
      {
        city: '丰台区',
        adcode: '110106', // 假设这里是丰台区的 adcode
        center: '116.286968,39.863642'
      }
    ]
  },
  上海: {
    adcode: '310000',
    districts: [
      {
        city: '上海',
        adcode: '310000',
        center: '121.473701,31.230416'
      },
      {
        city: '黄浦区',
        adcode: '310101',
        center: '121.490317,31.222999'
      },
      {
        city: '徐汇区',
        adcode: '310104',
        center: '121.437526,31.200112'
      },
      {
        city: '长宁区',
        adcode: '310105',
        center: '121.421005,31.218004'
      },
      {
        city: '静安区',
        adcode: '310106',
        center: '121.448224,31.224295'
      },
      {
        city: '普陀区',
        adcode: '310107',
        center: '121.397512,31.250332'
      },
      {
        city: '虹口区',
        adcode: '310109',
        center: '121.487159,31.262104'
      },
      {
        city: '杨浦区',
        adcode: '310110',
        center: '121.529270,31.267346'
      },
      {
        city: '闵行区',
        adcode: '310112',
        center: '121.387747,31.111144'
      },
      {
        city: '宝山区',
        adcode: '310113',
        center: '121.489004,31.398448'
      },
      {
        city: '南汇区',
        adcode: '310115',
        center: '121.887074,30.949627'
      },
      {
        city: '崇明区',
        adcode: '310151',
        center: '121.406187,31.616188'
      },
      {
        city: '浦东新区',
        adcode: '310115',
        center: '121.540211,31.222199'
      }
    ]
  }
};
var _that;
var scale; //加载比例尺插件
var mapObj; //初始化地图
var debounceHandle; //节流函数
var markerLists = []; //标记点数组
//聚合点样式
export default {
  activated() {
    window.$this = this;
  },
  data() {
    return {
      inputContent: '建外SOHO', //输入框输入的内容
      selectedCity: '北京', //第一个 下拉选项城市   默认选中的值
      selectedRegion: '北京', //第二个 下拉选项区域 默认选中的值
      district,
      filteredPoints: [], //检索出来的数据
      workOrderList: [], //工单列表数据
      DropdownDisplayManager: false, //是否显示 检索出来的数据
      showSearchSuggestions: false, //是否显示搜索提示词
      activeDiv: null, //上一个点击过的的 街道标注 div
      CellName: {}, //当前点击的小区数据
      requestType: 'city', //值为“city”时发送区域城市请求；当值为district时，表示是区域请求。。。。
      points: [], //请求拿到的数据 要标记的mark点
      totalCount: 0, //可视区域内为小区总数
      northwest: [], //西北
      eastsouth: [], //东南
      //字典项目
      options: {
        cascadeCode_repairParts: { codeId: 'repairParts' }
      }
    };
  },
  mounted() {
    window.$this = this;
    //挂载阶段调用，DOM初始化完成进行地图初始化
    this.initMap();
    //将原来的处理方法传入防抖函数，并指定时间间隔
    debounceHandle = this.debounce(this.getListData, 150);
    //请求字典项
    this.osg.codeoption();
  },
  watch: {
    //西北
    northwest() {
      //防抖请求数据
      debounceHandle();
    }
  },
  methods: {
    getListData() {
      let params = {
        groupType: this.requestType, //当前等级
        maxLatitude: this.northwest.lat, // 西北的纬度是最大纬度
        minLatitude: this.eastsouth.lat, // 东南的纬度是最小纬度
        maxLongitude: this.eastsouth.lng, // 东南的经度是最大经度
        minLongitude: this.northwest.lng // 西北的经度是最小经度
      };
      this.osg.ajax(
        '/basic/neighborhood/queryNeighborhoodByLatitudeAndLongitude.do',
        params,
        ({ data }) => {
          this.points = data; // 将响应数据赋值给 this.points
          this.totalCount = 0; // 初始化总数
          const markersToAdd = data.map(item => {
            this.totalCount = item.count ? this.totalCount + item.count : data.length;

            var markerContent = document.createElement('div');
            markerContent.className = 'custom-content-marker';

            var firstSpan = document.createElement('span');
            firstSpan.textContent = item.name;
            markerContent.appendChild(firstSpan);
            //当当前层级不为小区的时候 显示名称+小区数量
            if (this.requestType !== 'name') {
              //数量
              var secondSpan = document.createElement('span');
              secondSpan.textContent = `${item.count}个`;
              secondSpan.style.color = '#ffffffb3';
              markerContent.style.borderRadius = '50%';
              markerContent.appendChild(secondSpan);
            } else if (this.requestType == 'name') {
              markerContent.style.borderRadius = '100px';
              markerContent.style.padding = '5px 10px';
              markerContent.style.width = 'auto';
              markerContent.style.height = 'auto';
            }
            markerContent.style.backgroundColor = '#3072f6';
            var marker = new AMap.Marker({
              position: new AMap.LngLat(item.lnglat[0], item.lnglat[1]),
              // 将 html 传给 content
              content: markerContent,
              clickable: true
            });
            if (item.name == this.CellName.name) {
              const markerElement = marker.getContent();
              this.activeDiv = markerElement;
              markerElement.classList.add('my-custom-class');
            }
            //给标记点添加点击事件
            marker.on('click', e => {
              if (this.activeDiv) {
                this.activeDiv.classList.remove('my-custom-class');
                this.activeDiv.classList.add('BMapLabel');
              }
              if (this.newZoom < 16) {
                this.newZoom += 2;
              }
              if (this.requestType == 'name') {
                //打开小区工单列表
                this.DropdownDisplayManager = true;
                //显示小区
                this.CellName = item;
                const markerElement = marker.getContent();
                this.activeDiv = markerElement;
                markerElement.classList.add('my-custom-class');
                //查询工单列列表
                this.getServiceAppointment(item);
              } else {
                mapObj.setZoomAndCenter(this.newZoom, e.lnglat, false, 1000);
              }
              // 通过 marker.getContent() 获取 DOM 结构
              // const markerElement = marker.getContent();
              //  获取用户自定义数据
              //  const getExtData = marker.getExtData();
              // this.activeDiv = markerElement;
              // this.activeDiv.classList.add('my-custom-class'); // 添加自定义类
              // markerElement.style.backgroundColor = 'red';
              // console.log(markerElement);
            });

            return marker;
          });

          mapObj.remove(markerLists);
          markerLists = [];
          markerLists.concat(markersToAdd);
          markersToAdd.forEach(marker => {
            markerLists.push(marker);
            mapObj.add(marker);
          });
        },
        { noload: true }
      );
    },
    //查询工单列列表
    getServiceAppointment(item) {
      this.osg.ajax(
        '/basic/serviceAppointment/query.do',
        {
          'is:community|string#or': item.name,
          ' is:exts.nhId|string#or': item.id || item._id,
          rows: 100
        },
        ({ data }) => {
          this.workOrderList = data;
          console.log('查询工单列列表', data);
        },
        { noload: true }
      );
    },
    //防抖
    debounce(fn, delay) {
      let timer = null;
      return function() {
        let context = this;
        let args = arguments;
        clearTimeout(timer);
        timer = setTimeout(function() {
          fn.apply(context, args);
        }, delay);
      };
    },
    initMap() {
      _that = this;
      window._AMapSecurityConfig = {
        securityJsCode: '3788aba03fd31c6043d09d13ef61a9fd'
      };
      AMapLoader.load({
        key: '1a9bad1cbe81dd0c59194c657566254b', //此处填入我们注册账号后获取的Key
        version: '2.0', //指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
        plugins: [''] //需要使用的的插件列表，如比例尺'AMap.Scale'等
      })
        .then(async AMap => {
          mapObj = new AMap.Map('container', {
            //设置地图容器id
            viewMode: '2D', //是否为3D地图模式
            zoom: 9, //初始化地图级别
            center: [116.397428, 39.90923], //初始化地图中心点位置
            // mapStyle: 'amap://styles/grey',
            zooms: [8, 18]
          });

          mapObj.plugin(
            [
              'AMap.Scale',
              'AMap.ToolBar',
              'AMap.DistrictSearch',
              'AMap.PlaceSearch',
              'AMap.Geocoder',
              'AMap.Marker',
              'AMap.Pixel'
            ],
            function() {
              //加载比例尺插件
              scale = new AMap.Scale();
              mapObj.addControl(scale);
              //显示比例尺插件
              scale.show();
              //简易缩放按钮
              mapObj.addControl(new AMap.ToolBar());
              _that.northwest = mapObj.getBounds().getNorthWest(); //西北
              _that.eastsouth = mapObj.getBounds().getSouthEast(); //东南
              const amapToolbar = document.querySelector('.amap-toolbar');
              // 添加点击事件到缩放按钮事件
              amapToolbar.addEventListener('click', function() {
                // 在这里添加放大地图的逻辑
                _that.getMapDetails();
              });
            }
          );

          mapObj.on('moveend', async () => {
            this.getMapDetails();
          });
        })
        .catch(e => {
          console.log(e);
        });
    },
    //更改经纬度
    getMapDetails() {
      this.newZoom = Math.round(mapObj.getZoom());
      switch (true) {
        case this.newZoom >= 2 && this.newZoom < 10:
          this.requestType = 'city';
          break;
        case this.newZoom >= 10 && this.newZoom < 12:
          this.requestType = 'district';
          break;
        case this.newZoom >= 12 && this.newZoom < 15:
          this.requestType = 'subdistrict';
          break;
        case this.newZoom >= 15 && this.newZoom < 22:
          this.requestType = 'name';
          break;
        default:
      }
      this.northwest = mapObj.getBounds().getNorthWest(); //西北
      this.eastsouth = mapObj.getBounds().getSouthEast(); //东南
    },
    //搜索框 事件
    handleSelect() {
      // 如果查到数据了 就定位到某个点
      if (this.filteredPoints.length > 0 && this.inputContent.trim() != '') {
        //关闭搜索提示词
        this.showSearchSuggestions = false;
        //打开小区工单列表
        this.DropdownDisplayManager = true;
        //点击的小区对象
        this.CellName = this.filteredPoints[0];
        this.getServiceAppointment(this.CellName);
        mapObj.setZoomAndCenter(17, [this.CellName.longitude, this.CellName.latitude]);
      }
    },
    //输入框聚焦点事件
    inputfocus() {
      if (this.inputContent.trim() != '') {
        //关闭搜索提示词
        this.showSearchSuggestions = true;
      }
    },
    //失去焦点的时候触发
    inputblur() {
      //关闭搜索提示词
      this.showSearchSuggestions = false;
    },
    //输入框改变事件
    inputChange() {
      //去除首位空格不为空的时候发生请求拿数据
      if (this.inputContent.trim() == '') {
        //失去焦点事件
        this.showSearchSuggestions = false;
        return;
      }
      this.showSearchSuggestions = true;
      //拿到的那个对象
      let districtObj = this.district[this.selectedCity];

      let province = districtObj.adcode; // 市的 adcode
      let city = districtObj.districts.find(item => item.city === this.selectedRegion).adcode; //区的code
      //根据输入框的名称来去拿到所有的名称
      this.osg.ajax(
        '/basic/neighborhood/query.do',
        {
          'regex:name|string#and': this.inputContent,
          'is:city|string#and': city === province ? '' : city,
          'is:province|string#and': province,
          rows: 20
        },
        ({ data }) => {
          this.filteredPoints = data;
          console.log('输入框改变事件', this.filteredPoints);
        },
        { noload: true }
      );
    },
    //收缩提示词 进行标蓝色事件
    highlightMatches(text) {
      const regex = new RegExp(`(${this.inputContent})`, 'gi'); // 创建正则表达式，忽略大小写
      return text.replace(regex, '<span style="color: #3072f6;">$1</span>'); // 用红色的 span 包裹匹配的字
    },
    //点击提示词 定位到目标点
    navigateToMarker(item) {
      mapObj.setZoomAndCenter(17, [item.longitude, item.latitude]);
      this.getServiceAppointment(item);
      this.inputContent = item.name;
      //关闭搜索提示词
      this.showSearchSuggestions = false;
      //打开小区工单列表
      this.DropdownDisplayManager = true;
      //显示小区对象
      this.CellName = item;
    },
    //滚动条触底事件
    handleScroll(event) {
      const element = event.target;
      const isAtBottom = element.scrollHeight - element.scrollTop <= element.clientHeight;
      if (isAtBottom) {
        // 触底事件处理逻辑
        console.log('已触底，加载更多数据');
        // this.loadMoreData(); // 调用加载更多数据的方法
      }
    },
    //下拉列表点击事件
    handleCommand(e, type) {
      console.log(e, type);

      this[type] = e;
      if (type === 'selectedCity') {
        this.selectedRegion = district[e].districts[0].city;
      }
    },
    //是否展开搜索菜单列表
    WebClick() {
      this.DropdownDisplayManager = !this.DropdownDisplayManager;
    }
  }
};
</script>

<style lang="scss">
.page {
  width: 100vw;
  height: 100vh;
  position: relative;
}

//输入框相关样式
.info {
  width: 375px;
  height: 24px;
  padding: 12px 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 0.25rem;
  position: absolute;
  top: 24px;
  background-color: white;
  border-width: 0;
  left: 2%;
  z-index: 10;
  box-shadow: 0 2px 6px 0 rgba(114, 124, 245, 0.5);
  .querySearchBox {
    height: 100%;
    display: flex;
    align-items: center;
    .line {
      height: 100%;
      width: 1px;
      border-right: 2px solid #ececec;
    }
    .el-input__inner {
      height: 24px;
      padding: 0 5px;
      border: none; /* 默认没有边框 */
      box-shadow: none; /* 去掉阴影 */
    }
    .el-input__inner:focus {
      border: none; /* 聚焦时仍然去掉边框 */
      box-shadow: 0 0 0 1px #93a6ff; /* 使用阴影来代替边框 */
      outline: none; /* 去掉默认的轮廓样式 */
    }
    //输入框清除按钮
    .el-input__suffix {
      display: flex;
      align-items: center;
    }
    // 鼠标悬停时变为小手
    .el-icon-search {
      cursor: pointer;
    }
  }
}
//检索列表数据样式
.result {
  width: 375px;
  max-height: 400px;
  height: auto;
  padding: 0px 16px;
  border-radius: 0.25rem;
  position: absolute;
  display: flex;
  flex-direction: column;
  top: 88px;
  background-color: white;
  border-width: 0;
  left: 2%;
  z-index: 10;
  box-shadow: 0 2px 6px 0 rgba(114, 124, 245, 0.5);
  .title {
    font-size: 14px;
    color: #222;
    height: 50px;
    line-height: 50px;
    border-bottom: 1px solid #f0f0f0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .close-item {
      cursor: pointer; /* 悬浮时变为小手 */
    }
  }

  .plot_card {
    overflow: auto;
    //padding 0px 16px 让滚动条显示的自然一些
    margin-right: -16px;
    cursor: pointer; /* 悬浮时变为小手 */
  }
  .result_box {
    height: 100px;
    margin: 12px 0;
    border-radius: 0.25rem;
    display: flex;
    justify-content: space-around;
  }
}

//点击后的css样式
.BMapLabel {
  background-color: #97b8fb !important;
}
//点击时的css样式
.my-custom-class {
  background-color: #e8634c !important;
}

.custom-content-marker {
  position: relative;
  height: 84px;
  width: 84px;
  // background-color: rgba(8, 60, 156, 0.8);
  justify-content: center;
  font-size: 12px;
  overflow: hidden;
  font-family: PingFangSC-Semibold;
  display: flex;
  align-items: center;
  flex-direction: column;
  span {
    width: 100%;
    text-align: center;
    color: #fff;
    white-space: nowrap; /* 不允许换行 */
    overflow: hidden; /* 超出隐藏 */
    text-overflow: ellipsis; /* 省略文本 */
  }
}
.custom-content-marker:hover {
  background-color: #e8634c !important;
}
.cellName:hover {
  color: #3072f6;
  cursor: pointer;
}
</style>
